export default "__VITE_ASSET__34d4190d__"